import * as RadixAvatar from '@radix-ui/react-avatar'

interface AvatarProps {
  src?: string
  name: string
  size?: number
  online?: boolean
}

const COLORS = [
  'bg-blue-500', 'bg-green-500', 'bg-yellow-500',
  'bg-red-500',  'bg-purple-500', 'bg-pink-500',
]

function colorFor(name: string) {
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) & 0xffff
  return COLORS[h % COLORS.length]
}

function initials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  const trimmed = name.trim()
  return trimmed ? trimmed.slice(0, 2).toUpperCase() : '?'
}

export function Avatar({ src, name, size = 40, online }: AvatarProps) {
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <RadixAvatar.Root
        className={`flex items-center justify-center rounded-full overflow-hidden ${colorFor(name)}`}
        style={{ width: size, height: size }}
      >
        <RadixAvatar.Image
          src={src}
          alt={name}
          className="w-full h-full object-cover"
        />
        <RadixAvatar.Fallback
          className="text-white font-medium select-none"
          style={{ fontSize: size * 0.38 }}
        >
          {initials(name)}
        </RadixAvatar.Fallback>
      </RadixAvatar.Root>

      {online && (
        <span
          className="absolute bottom-0 right-0 block rounded-full bg-green-400 ring-2 ring-bg-primary"
          style={{ width: size * 0.28, height: size * 0.28 }}
        />
      )}
    </div>
  )
}
